import ExaminersStatics from './pages/Workspace/JobsHistory/containers/ExaminersStatics';
import ExamResults from './pages/Workspace/JobsHistory/containers/ExamResults';
import ExamSheet from './pages/Workspace/JobsHistory/containers/ExamSheet';
import Jobs from './pages/Workspace/JobsHistory/containers/Jobs';
import { BrowserRouter, history } from './router/BrowserRouter';
import { selectNotification } from './store/general/selectors';
import { ProtectedRoute } from './router/ProtectedRoute';
import JobsHistory from './pages/Workspace/JobsHistory';
import { PrivateRoute } from './router/PrivateRoute';
import ForgetPassword from './pages/ForgetPassword';
import { useBootstrap } from './hooks/useBootstrap';
import Dashboard from './pages/Workspace/Dashboard';
import { Routes, Route } from 'react-router-dom';
import PostJob from './pages/Workspace/PostJob';
import Payment from './pages/Workspace/Payment';
import Support from './pages/Workspace/Support';
import Account from './pages/Workspace/Account';
import EditJob from './pages/Workspace/EditJob';
import Legal from './pages/Workspace/Legal';
import { useSelector } from './store/store';
import Workspace from './pages/Workspace';
import NotFound from './pages/NotFound';
import Toast from './components/Toast';
import Welcome from './pages/Welcome';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';

function App() {
    useBootstrap();
    const notifications = useSelector(selectNotification);

    return (
        <BrowserRouter history={history}>
            <Routes>

                <Route path='/' element={<ProtectedRoute />} >
                    <Route path='' element={<Welcome />} />
                    <Route path='/signup' element={<SignUp />} />
                    <Route path='/signin' element={<SignIn />} />
                    <Route path='/forgetpassword' element={<ForgetPassword />} />
                </Route>

                <Route path='/workspace' element={<PrivateRoute />} >
                    <Route path='' element={<Workspace />} >
                        <Route path='' element={<Dashboard />} />
                        <Route path='account' element={<Account />} />
                        <Route path='postjob' element={<PostJob />} />
                        <Route path='edit-job' element={<EditJob />} />
                        <Route path='legal' element={<Legal />} />
                        <Route path='payment' element={<Payment />} />
                        <Route path='support' element={<Support />} />
                        <Route path='history' element={<JobsHistory />} >
                            <Route path='' element={<Jobs />} />
                            <Route path=':jobId' element={<ExaminersStatics />} />
                            <Route path=':jobId/sheet' element={<ExamSheet />} />
                            <Route path=':jobId/:examinerId' element={<ExamResults />} />
                        </Route>
                    </Route>
                </Route>

                <Route path='*' element={<NotFound />} />
            </Routes>
            <Toast autoDelete dismissTime={3000} toastList={notifications} />
        </BrowserRouter>
    );
};

export default App;